module.exports = __webpack_public_path__ + "img/segera-hadir.3c7fcd82.svg";